import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Patient.module.css';
import VitalsView from './PatientViews/VitalsView';
import CareProgramView from './PatientViews/CareProgramView';
import { resetFilterState, setFilterItem } from './Slices/PatientDetailFilterSlice';
import DetailsView from './PatientViews/DetailsView';
import CareTeamView from './PatientViews/CareTeamView';
import ReportsView from './PatientViews/ReportsView';
import NotesView from './PatientViews/NotesView';
import QuestionnaireView from './PatientViews/QuestionnaireView';
import DeviceInfoView from './PatientViews/DeviceInfoView';
import DeviceManagementView from './PatientViews/DeviceManagementView';
import { setMenuItem } from './Slices/PatientDetailSlice';
import AlarmsView from './PatientViews/AlarmsView';

const PatientDetailBody = () => {
  const selectedMenuItem = useSelector((state)=>state.patientDetailsSlice.detailTab);
  const alerts = useSelector((state)=>state.patient.alerts);
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(resetFilterState());
  },[]);

  const views = {
    'Vitals': <VitalsView />,
    'Alarms': <AlarmsView />,
    'CareProgram': <CareProgramView />,
    'PatientDetails': <DetailsView />,
    'CareTeam': <CareTeamView />,
    'Reports': <ReportsView />,
    'Notes': <NotesView />,
    'Questionnaire': <QuestionnaireView />,
    'DeviceInfo': <DeviceInfoView />,
    'DeviceManagement': <DeviceManagementView />
  };

  const onMenuItemClick = (name) => {
    dispatch(setMenuItem(name))
    dispatch(setFilterItem({key:"selectedScrollChart", value: ''}))
  }

  return (
    <div className={styles.BodyContainer}>
      <div className={styles.PatientDetailsList}>
        <div
          className={selectedMenuItem === 'Vitals' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('Vitals')}
        >
          <p>Vitals</p>
        </div>
        <div
          className={selectedMenuItem === 'Alarms' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('Alarms')}
        >
          <p>{`Alarms (${alerts?.active?.clinical.length + alerts?.active?.technical.length + alerts?.active?.operational.length})`}</p>
        </div>
        <div
          className={selectedMenuItem === 'Questionnaire' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('Questionnaire')}
        >
          <p>Questionnaire</p>
        </div>
        <div
          className={selectedMenuItem === 'Notes' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('Notes')}
        >
          <p>Notes</p>
        </div>
        <div
          className={selectedMenuItem === 'Reports' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('Reports')}
        >
          <p>Patient-Submitted Reports</p>
        </div>
        <div
          className={selectedMenuItem === 'CareProgram' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('CareProgram')}
        >
          <p>Care Program</p>
        </div>
        <div
          className={selectedMenuItem === 'CareTeam' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('CareTeam')}
        >
          <p>Care Team</p>
        </div>
        <div
          className={selectedMenuItem === 'PatientDetails' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('PatientDetails')}
        >
          <p>Patient Details</p>
        </div>
        <div
          className={selectedMenuItem === 'DeviceInfo' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('DeviceInfo')}
        >
          <p>Device Info</p>
        </div>
        <div
          className={selectedMenuItem === 'DeviceManagement' ? styles.Selected : ''}
          onClick={() => onMenuItemClick('DeviceManagement')}
        >
          <p>Device Management</p>
        </div>
      </div>
      {views[selectedMenuItem]}
    </div>
  );
};

export default PatientDetailBody;
